module.exports = __webpack_public_path__ + "media/images/icon-student-b0f36b6c9b50e657623abe34d156e517.jpg";